import { CustomerEditAgentListComponent } from './customer-edit-agent-list/customer-edit-agent-list.component';
import { CustomerEditViewComponent } from './customer-edit-view/customer-edit-view.component';
import { CustomerLookupResolveService } from './shared/services/customer-lookup-resolve.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CustomersShellComponent } from './customers-shell/customers-shell.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomerViewComponent } from './customer-view/customer-view.component';
import { RouteApplicationStartupResolveService } from '../core/route-application-startup-resolve.service';
import { CustomersModerationComponent } from './customers-moderation/customers-moderation.component';
import { AuthGuard } from '../core/auth.guard';

const routes: Routes = [
  {
    path: 'customers',
    component: CustomersShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: CustomerLookupResolveService,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'list',
      },
      {
        path: 'list',
        component: CustomerListComponent,
      },
      {
        path: 'view/:id',
        component: CustomerViewComponent,
      },
      {
        path: 'edit/:id',
        component: CustomerEditViewComponent,
        data: { tabIndex: 0 },
      },
      {
        path: 'moderation/:id',
        component: CustomersModerationComponent,
      },
      {
        path: 'edit/:id/details',
        component: CustomerEditViewComponent,
        data: { tabIndex: 0 },
      },
      {
        path: 'edit/:id/billing',
        component: CustomerEditViewComponent,
        data: { tabIndex: 1 },
      },
      {
        path: 'edit/:id/agents',
        component: CustomerEditViewComponent,
        data: { tabIndex: 2 },
      },
      {
        path: 'edit/:id/contracts',
        component: CustomerEditViewComponent,
        data: { tabIndex: 3 },
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomersRoutingModule {}
